import { createContext, useContext, type ReactNode } from 'react';
import { useEmailsDir } from '../model';
import type { OffEmailsDirProps } from '../model';

const EmailsDirContext = createContext<ReturnType<typeof useEmailsDir> | null>(null);

export const useEmailsDirectory = () => {
    const value = useContext(EmailsDirContext);
    if (!value) throw new Error('EmailsDirProvider is required');
    return value;
};

const EmailsDirProvider = ({ children, ...props }: OffEmailsDirProps & { children: ReactNode }) => {
    const value = useEmailsDir(props);
    return <EmailsDirContext.Provider value={value}>{children}</EmailsDirContext.Provider>;
};

export default EmailsDirProvider;
